module.exports = __webpack_public_path__ + "static/assets/3b38f398387ca75048e1418557786db2.svg";